import React from 'react';

const MaterialIcon = React.forwardRef(
	function MaterialIcon({ children, className = '', ...otherProps }, ref) {
		return (
			<i
				className={`material-icons ${className}`}
				ref={ref}
				{...otherProps}
			>
				{children}
			</i>
		);
	}
);

export default MaterialIcon;